import { RoleResponse } from '../types/user';
import { fetchAsync } from '../utils/fetch';

export const fetchRoles = (): Promise<RoleResponse[]> => fetchAsync('/api/role');
